import { useCallback, useMemo } from 'react';
import { EBreadcrumbKey } from '~/shared/types';
import { ROUTES } from '~/routes/routes';
import { useNavigate } from 'react-router-dom';
import { useService } from '~/services/service.base';
import { ServiceCategoryTag } from '~/services/service.category.tag';
import { ServicePaginator } from '~/services/service.paginator';
import { runInAction } from 'mobx';
import { getBreadcrumbs } from '~/tools/breadcrumb';
export const useActions = (mediasSearchService, state, serviceMediaCategories, categoryPropertiesService, breadcrumbsSvc) => {
    const navigate = useNavigate();
    const serviceCategoryTag = useService(ServiceCategoryTag);
    const servicePaginator = useService(ServicePaginator);
    const defaultBreadcrumbItems = useMemo(() => [
        {
            key: EBreadcrumbKey.repository,
        },
    ], []);
    const clickByCategoryHandler = useCallback((category) => {
        servicePaginator.resetPaginatorData();
        mediasSearchService.addSubCategory({
            breadCrumbName: category.title,
            breadCrumbId: category.id,
            index: state?.categories?.categoryIndex,
        });
        breadcrumbsSvc.use(getBreadcrumbs(defaultBreadcrumbItems, mediasSearchService));
        if (!category.hasChildren) {
            runInAction(() => {
                mediasSearchService.setCategoryId(category.id);
            });
            if (category.hasTags) {
                runInAction(() => {
                    serviceCategoryTag.setCategoryId(category.id);
                    serviceCategoryTag.getTags();
                });
            }
            mediasSearchService.getMediaItems(undefined, undefined, mediasSearchService.tags);
            navigate(ROUTES.FUNDS.MEDIA.CATEGORY_CONTENT.path);
            return;
        }
        serviceMediaCategories.setCategoryId(category.id);
        runInAction(() => serviceMediaCategories.getCategories(serviceMediaCategories.sorting));
        navigate(ROUTES.FUNDS.MEDIA.SUB_CATEGORY.path);
    }, [
        breadcrumbsSvc,
        defaultBreadcrumbItems,
        mediasSearchService,
        navigate,
        serviceCategoryTag,
        serviceMediaCategories,
        servicePaginator,
        state?.categories?.categoryIndex,
    ]);
    const clickByCategoryInfoHandler = useCallback((category) => {
        runInAction(() => {
            categoryPropertiesService.setCategory(category);
            categoryPropertiesService.getProperties();
        });
        categoryPropertiesService.openDialogService.handleOpen();
    }, [categoryPropertiesService]);
    return {
        clickByCategoryInfoHandler,
        clickByCategoryHandler,
    };
};
